import { render, staticRenderFns } from "./PlayerMilestones.vue?vue&type=template&id=5507e62b&scoped=true&"
import script from "./PlayerMilestones.vue?vue&type=script&lang=js&"
export * from "./PlayerMilestones.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMilestones.vue?vue&type=style&index=0&id=5507e62b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5507e62b",
  null
  
)

export default component.exports